import { useMemo } from "react";
import { InitialSpecialPackageItemInfo } from "../../types/client";
import { GetSpecialPackageData } from "../../types/response";
import { PackageCard } from "../../components/layout/Admin/clients/ClientModalBasicPackage";
import { DefaultPackageData } from "../../features/package/packageResponse";

export const useClientModalBasicPackageUseMemo = (
    getBasicPackage:  DefaultPackageData | undefined,
    getSpecialPackages: GetSpecialPackageData[],
    specialPackageItems: InitialSpecialPackageItemInfo[] | undefined,
    selectedPackageId: number | undefined
) => {

    const activeSpecialPackages = useMemo(() => {
        // return getSpecialPackages.filter((pkg) => pkg.isActive);

        return getSpecialPackages
            .filter((pkg) => pkg.isActive)
            .map((pkg) => ({
                ...pkg,
                product: pkg.products
                    .filter((product) => product.isAvailable)
                    .map((product) => ({
                        ...product,
                        addons: (product.addons ?? []).filter(
                            (addon) => addon.isActive
                        ),
                    })),
            }));

    }, [getSpecialPackages]);
    
    const packages = useMemo(() => {
        const data: PackageCard[] = [];

        if (getBasicPackage) {
            data.push({
                type: "basic",
                id: getBasicPackage.packageID,
                name: getBasicPackage.packageName,
                cups: getBasicPackage.qty,
                amount: null,
                totalProduct: null,
                items: null,
            });
        }

        activeSpecialPackages.forEach((special) => {
            data.push({
                type: "special",
                id: special.specialPackageID,
                name: special.packageName,
                cups: null,
                amount: Number(special.packageAmount),
                totalProduct:
                    special.products.length + (specialPackageItems?.length ?? 0),
                items: special.products
            });
        });

        return data;
    }, [getBasicPackage, activeSpecialPackages, specialPackageItems]);

    const selectedPackageItem = useMemo(() => {
        return packages.find(pkg => pkg.id === selectedPackageId)?.items ?? [];
    }, [packages, selectedPackageId]);

    return {
        activeSpecialPackages,
        packages,
        selectedPackageItem,
    }
}